import { render, staticRenderFns } from "./MemberAlertsDisplay.vue?vue&type=template&id=4d6d5446&scoped=true"
import script from "./MemberAlertsDisplay.vue?vue&type=script&lang=js"
export * from "./MemberAlertsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d5446",
  null
  
)

export default component.exports